module.exports = __webpack_public_path__ + "img/figure-10.a7a55532.png";